document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ccta__form').forEach(form => {
    form.addEventListener('submit', () => {
      const btn = form.querySelector('.ccta__btn');
      if (btn) { btn.disabled = true; btn.textContent = (btn.textContent || 'Submitting') + '...'; }
    });
  });
});
